import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getComboTipoInstalacion`, method: 'GET', body: null, token: token})
}